var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("iframe", {
    ref: "frame",
    staticClass: "my-dialog-frame",
    attrs: {
      src: _vm.src,
      frameborder: "0"
    },
    on: {
      load: _vm.handleLoad
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };